import { useContext } from 'react';
import { SuperFieldContext } from './contexts';
export var useSuperFieldContext = function useSuperFieldContext() {
  var context = useContext(SuperFieldContext);
  return context;
};